import * as React from 'react';
import { SaveSearchContainer } from 'shared/common/packages/SaveSearchModal';

export const SaveSearchModalContainer: React.FC = () => {
  return <SaveSearchContainer />;
};
